import { useEffect } from "react";

const SITE = "GEO DRAFTING";
// Canonical production domain (stated by the client). Never derive from window.location — the preview host is disposable.
export const SITE_URL = "https://geodrafting.com";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;
const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const GEO = { US: ["US", "United States"], CA: ["CA", "Canada"], GB: ["GB", "United Kingdom"], AU: ["AU", "Australia"], IN: ["IN", "India"] };
export const faqLd = (faq) => ({ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faq.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) });
export const breadcrumbLd = (crumbs) => ({ "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: crumbs.map(([name, to], i) => ({ "@type": "ListItem", position: i + 1, name, ...(to ? { item: `${SITE_URL}${to === "/" ? "/" : to + "/"}` } : {}) })) });

/* geo: "US" | "US-TX" | "CA" | "GB" | "AU" | "IN"; hreflang: { "en-US": "/path", "en-GB": "/path", ... } (x-default added automatically); crumbs → BreadcrumbList */
export const useSeo = (opts) => {
  const { title, description, path = "/", jsonLd, keywords, geo, hreflang, crumbs, lang = "en" } = opts || {};
  useEffect(() => {
    if (!opts) return; // pass null when a child component owns the page's SEO
    const full = title.includes(SITE) ? title : `${title} | ${SITE}`;
    const abs = (p) => `${SITE_URL}${p === "/" ? "/" : p.replace(/\/?$/, "/")}`;
    const url = abs(path);
    document.title = full;
    document.documentElement.lang = lang;
    setMeta("name", "description", description);
    setMeta("name", "robots", "index, follow, max-snippet:-1, max-image-preview:large");
    if (keywords?.length) setMeta("name", "keywords", keywords.join(", "));
    if (geo) { const [region, place] = GEO[geo.split("-")[0]] || [geo, geo]; setMeta("name", "geo.region", geo); setMeta("name", "geo.placename", geo.includes("-") ? geo : place); }
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", OG_IMAGE);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((n) => n.remove());
    if (hreflang) Object.entries({ ...hreflang, "x-default": hreflang["x-default"] || hreflang["en-US"] || path }).forEach(([hl, p]) => {
      const a = document.createElement("link"); a.rel = "alternate"; a.hreflang = hl; a.href = abs(p); document.head.appendChild(a);
    });
    const graph = [...(Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []), ...(crumbs && crumbs.length > 1 ? [breadcrumbLd(crumbs)] : [])].filter(Boolean);
    let ld = document.getElementById("page-jsonld");
    if (graph.length) {
      if (!ld) { ld = document.createElement("script"); ld.type = "application/ld+json"; ld.id = "page-jsonld"; document.head.appendChild(ld); }
      ld.textContent = JSON.stringify(graph.length === 1 ? graph[0] : graph);
    } else if (ld) ld.remove();
  }, [opts, title, description, path, jsonLd, keywords, geo, hreflang, crumbs, lang]);
};

export const ORG_LD = {
  "@context": "https://schema.org", "@type": "Organization", name: "GEO DRAFTING",
  slogan: "From Coordinates to CAD Excellence.", email: "survey@geodrafting.com",
  telephone: ["+918083691588", "+12627398208"],
  address: [
    { "@type": "PostalAddress", streetAddress: "Sanskruti Apartment, Basement, 11th Ln, Laxmi Nagar", addressLocality: "Jaysingpur", addressRegion: "Maharashtra", postalCode: "416101", addressCountry: "IN" },
    { "@type": "PostalAddress", streetAddress: "2424 W Brandon Blvd", addressLocality: "Brandon", addressRegion: "FL", postalCode: "33511", addressCountry: "US" },
  ],
  areaServed: ["US", "CA", "AU", "GB", "IN"],
  openingHours: ["Mo-Fr 08:00-18:00", "Sa 09:00-14:00"],
  url: SITE_URL, logo: `${SITE_URL}/favicon.svg`, image: OG_IMAGE,
  description: "Land survey CAD drafting services, survey data processing and geospatial CAD for surveying and engineering firms in the USA, Canada, Australia and the UK.",
};
